// extracted by mini-css-extract-plugin
var _1 = "dashedline_horizontal__prhum";
var _2 = "dashedline_line__qaura";
export { _1 as "horizontal", _2 as "line" }
